/* eslint-disable import/no-named-as-default-member */
import { ContractFileType } from '@/enums/contract-type';
import ProductCommodity, {
  SHIGUANGFENQI_COMMODITY,
  SUNING_COMMODITY,
  NEWORAGE_COMMODITY,
  ZHAOJILING_COMMODITY,
  WEIPINXIAOJIN_COMMODITY,
  TONGCHENG_COMMODITY,
  MINSHENG_COMMODITY,
  ZHONGYOU_COMMODITY,
  ZHONGYIN_COMMODITY,
  NEW_YINHE_COMMODITY,
  ALIPAYMINI_COMMODITY,
} from '../commodity';

/** 借贷各阶段名称定义 */
export enum PROCESS_TYPE {
  /** 贷前 */
  PRE_LENDING = 'pre-lending',
  /** 贷中 */
  LENDING = 'lending',
  /** 贷后 */
  POST_LENDING = 'post-lending'
}

/**
 * 贷后合同-特殊渠道配置：pdf格式协议、跨域协议，通过新webview打开协议
 */
export const localPostLendingSpecialConfig = {
  [SHIGUANGFENQI_COMMODITY]: ContractFileType.PDF,
  [ProductCommodity.ZHONGYUAN_UNION_COMMODITY]: ContractFileType.NORMAL,
  [ProductCommodity.GUOMEI_NEW_COMMODITY]: ContractFileType.NORMAL,
  /** 苏宁银行，贷后合同是pdf，但是不支持跨域，只能走打开新的 WebView 的形式，通过新页面打开 */
  [SUNING_COMMODITY]: ContractFileType.NORMAL,
  /** 盛银 是pdf，支持跨域，但是 pdf 预览合同字体有问题，通过新 webview打开 */
  [ProductCommodity.SHENGYIN_COMMODITY]: ContractFileType.NORMAL,
  /** 8180渠道 pdf 预览合同字体有问题，通过新 webview打开 */
  [ProductCommodity.AUTARKY_B_COMMODITY]: ContractFileType.NORMAL,
  /** 桔子渠道 pdf 预览合同字体有问题，通过新 webview打开 */
  [NEWORAGE_COMMODITY]: ContractFileType.NORMAL,
  /** 招集令渠道 pdf 预览合同字体有问题，通过新 webview打开 */
  [ZHAOJILING_COMMODITY]: ContractFileType.NORMAL,
};

/**
 * 授信环节-特殊渠道列表：pdf格式协议
 * 以pdf预览模式打开
 */
export const credittingSpecialList = [
  WEIPINXIAOJIN_COMMODITY,
  TONGCHENG_COMMODITY,
  MINSHENG_COMMODITY,
  ZHONGYOU_COMMODITY,
  ZHONGYIN_COMMODITY,
  NEW_YINHE_COMMODITY,
  ALIPAYMINI_COMMODITY,
  ProductCommodity.YILIANBANK_COMMODITY,
  ProductCommodity.BAIXINBANK_COMMODITY,
  ProductCommodity.ZHONGYUAN_UNION_COMMODITY,
  ProductCommodity.AUTARKY_B_COMMODITY,
  ProductCommodity.FUMINBANK,
  ProductCommodity.YANGGUANG_COMMODITY,
  ProductCommodity.SUNINGBANK_COMMODITY,
  ProductCommodity.XINGLIHUA_COMMODITY,
  ProductCommodity.ZHONGYIDAI_COMMODITY,
  ProductCommodity.JUZI_WEIPIN_COMMODITY,
];

/**
 * 提现环节-特殊渠道列表：pdf格式协议
 * 以pdf预览模式打开
 */
export const withdrawingSpecialList = [
  WEIPINXIAOJIN_COMMODITY,
  TONGCHENG_COMMODITY,
  MINSHENG_COMMODITY,
  ZHONGYOU_COMMODITY,
  ZHONGYIN_COMMODITY,
  NEW_YINHE_COMMODITY,
  ALIPAYMINI_COMMODITY,
  ProductCommodity.YILIANBANK_COMMODITY,
  ProductCommodity.BAIXINBANK_COMMODITY,
  ProductCommodity.ZHONGYUAN_UNION_COMMODITY,
  ProductCommodity.FUMINBANK,
  ProductCommodity.YANGGUANG_COMMODITY,
];
